export default {
  size: {
    label: 'Standardpapiergröße',
    tooltip: 'Definiert die Papiergröße welche immer vorausgewählt ist.',
  },
  language: {
    label: 'Sprache',
    tooltip: 'Berichte zeigen die Texte ihrer Blöcke, Datumsangaben und Zahlen in dieser Sprache. Namen und andere von Benutzern eingegebene Texte bleiben unverändert.',
  },
  showTimezone: {
    label: 'Zeitzone anzeigen',
    tooltip: 'Datums- und Zeitangaben in Berichten nennen ihre Zeitzone, z. B. MEZ. Schalten Sie dies aus, wenn alle Ihre Standorte in einer Zeitzone liegen',
  },
  header: {
    height: {
      tooltip: 'Definiert die Höhe der Kopfzeile, die auf jeder Reportseite verwendet wird.',
    },
    contentLeft: {
      tooltip: 'Definiert den linken Kopfzeilentext, der auf jeder Reportseite angezeigt wird.',
    },
    contentCenter: {
      tooltip: 'Definiert den zentrierten Kopfzeilentext, der auf jeder Reportseite angezeigt wird.',
    },
    contentRight: {
      tooltip: 'Definiert den rechten Kopfzeilentext, der auf jeder Reportseite angezeigt wird.',
    },
  },
  footer: {
    contentLeft: {
      tooltip: 'Definiert den linken Fußzeilentext, der auf jeder Reportseite angezeigt wird.',
    },
    contentCenter: {
      tooltip: 'Definiert den zentrierten Fußzeilentext, der auf jeder Reportseite angezeigt wird.',
    },
    contentRight: {
      tooltip: 'Definiert den rechten Fußzeilentext, der auf jeder Reportseite angezeigt wird.',
    },
  },
};
